import { Component, forwardRef, OnChanges, KeyValueDiffers, Inject, Input, ChangeDetectorRef, ElementRef } from '@angular/core';
import { BlockComponent } from '../../../../Common/PageBuilder/components/Block/block.component';
import { AlertMentionListDisplayElementModel } from '../../models/alert-mention-list-display-element.model';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { ClickOutsideService } from '../../../../Common/PageBuilder/services/click-outside.service';

@Component({
    selector: 'agpr-alert-mention-list-block',
    templateUrl: './alert-mention-list-block.component.html',
    styleUrls: ['./alert-mention-list-block.component.scss'],
    providers: [
        {
            provide: BlockComponent,
            useExisting: forwardRef(() => AlertMentionListBlockComponent)
        }
    ],
    standalone: false
})
export class AlertMentionListBlockComponent extends BlockComponent implements OnChanges {

    displayElement: AlertMentionListDisplayElementModel;
    topicName: string;

    readonly messageSeverityEnum = messageSeverityEnum;

    constructor(
        public differs: KeyValueDiffers,
        public pageBuilderService: AbstractPageBuilderService,
        protected changeDetectorRef: ChangeDetectorRef,
        public clickOutsideService: ClickOutsideService,
        public el: ElementRef
    ) {
        super(differs, pageBuilderService, changeDetectorRef, clickOutsideService, el);
        this.id = 'alerts_mentionListBlock';
    }

    ngOnChanges(): void {
        super.ngOnChanges();
        this.displayElement = this.block.displayElement as AlertMentionListDisplayElementModel;
    }
}
